export default {
  get base_api_url() {
    const url = new URL(import.meta.env.VITE_API_BASE_URL)

    return `${url.protocol}//${url.hostname}`
  },
}
